export const colores = {
  white: '#fff',
  backgroundColor: '#fff',
  backgroundColorDark: '#E0E0E0',
  primary: '#4E5FBB',
  borderRadius: 10,
  borderColorCotton: '#FF4069',
  colorCotton: '#FFA0B4',
  borderColorSintetico: '#059BFF',
  colorSintetico: '#82CDFF',
  heightKPI: '150',
  primary100: '#E1F0D6',
  primary200: '#CCE3EE',
  primary300: '#B2CDDF',
  primary400: '#99BDD4',
  primary500: '#7FADC9',
  primary600: '#72a949',
  primary700: '#000000',
  // primary550: '#9c27b0',

  error: '#EF4444',

  // GRAY
  gray50: '#fafafa',
  gray100: '#F5F5F5',
  gray200: '#ECECEC',
  gray300: '#E0E0E0',
  gray400: '#BDBDBD',
  gray500: '#9E9E9E',
  gray600: '#757575',
  gray700: '#616161',
  gray800: '#424242',
  gray900: '#212121',
};

// COLORS ESTATUS

const verde = {
  backgroundColor: '#a1e279',
  color: '#0c0e0f',
};

const amarilloLemon = {
  backgroundColor: '#FFFACD',
  color: '#0e0c0f',
};

const naranjaclaro ={
  backgroundColor: '#fff0ba',
  color: '#0e0c0f',
}


const pendienteRevision = {
  backgroundColor: '#ffcdd2',
  color: '#c63737',
}

const urgente = {
  backgroundColor: '#ffcdd2',
  color: '#c63737',
}

const verdeClaro = {
  backgroundColor: '#e9ffd3', // verde claro, bajo
  color: '#0c0e0f',
};

const azul = {
  backgroundColor: '#cce5ff', // azul suave, normal
  color: '#0c0e0f',
};

const naranja = {
  backgroundColor: '#FFA500', // Naranja encendido
  color: '#0c0e0f',
};

const rojo = {
  backgroundColor: '#ffcccc', // rojo claro, crítico
  color: '#a30000',
};

const azulAsig = {
  backgroundColor: '#85C1E9', // rojo claro, crítico
  color: '#0c0e0f',
};


export const colorsStatus: {[key: string]: {backgroundColor: string; color: string};} = {
  //General
  status1: verde,
  status5: verde,

  status47: naranjaclaro,// Solicitado
  status48: azulAsig,// Asignado
  status49: verde,// En Proceso
  status51: pendienteRevision,// Detenido
  status52: amarilloLemon,// Revision

  //PRIORIDADES
  priority1: verdeClaro, //Bajo
  priority2: azul, //Normal
  priority3: naranja, //Urgente
  priority4: rojo, //Critico
};
